import React from 'react';
import './FeaturesList.css';

const FeaturesList = ({ section, isRightAligned }) => {
  if (!section) return null;

  const alignClass = isRightAligned ? "section-header-right mb-3 pb-4" : "mb-3 pb-4";
  const revealDirection = isRightAligned ? "reveal-from-left" : "reveal-from-right";
  const alignTextoDestino = isRightAligned ? "st-texto-destino-r" : "st-texto-destino-l";

  const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3030';
  const dynamicStyle = { minHeight: '80vh', position: 'relative', overflow: 'hidden' };

  if (section.background_type === 'color' || (!section.background_image_url && section.background_color)) {
    dynamicStyle.backgroundColor = section.background_color;
  }
  const opacityValue = (section.background_opacity || 100) / 100;

  // ==========================================
  // FILTRAGEM INTELIGENTE DOS DADOS DO BANCO
  // ==========================================
  const items = section.items || [];

  // Jurerê
  const jurereIntro = items.find(i => i.category === 'Jurerê' && i.is_intro)?.description || '';
  const jurereList = items.filter(i => i.category === 'Jurerê' && !i.is_intro);

  // Floripa
  const floripaIntro = items.find(i => i.category === 'Floripa' && i.is_intro)?.description || '';
  const floripaList = items.filter(i => i.category === 'Floripa' && !i.is_intro);


  return (
    <section id={section.slug} className="py-5" style={dynamicStyle}>
      {/* CAMADAS DE FUNDO */}
      {section.background_type === 'image' && section.background_image_url && (
        <>
          <div className="bg-parallax" style={{
            position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
            backgroundImage: `url(${backendUrl}${section.background_image_url})`,
            backgroundSize: 'cover', backgroundPosition: 'center', zIndex: 0
          }}></div>
          <div style={{
            position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.99)', opacity: opacityValue, zIndex: 1
          }}></div>
        </>
      )}

      {/* CAMADA DE CONTEÚDO */}
      <div className="container py-5" style={{ position: 'relative', zIndex: 2 }}>
        
        {/* DADOS PRINCIPAIS DA SEÇÃO (Títulos) */}
        <div className={alignClass}>
            <h2 className={`fonte-primaria display-4 section-title reveal-element ${revealDirection} duration-10`}>
                {section.title}
            </h2>
            {section.subtitle && (
              <h4 className={`fonte-terciaria section-subtitle mb-4 reveal-element ${revealDirection} duration-12`}>
                  {section.subtitle}
              </h4>
            )}
            {section.content && (
              <div className={`${alignTextoDestino} fonte-terciaria  lead text-dark reveal-element ${revealDirection} duration-14`}>
                 <p className="mb-4">{section.content}</p>
              </div>
            )}
        </div>

        {/* ================================================= */}
        {/* BLOCO 1: JURERÊ (SÓ APARECE SE TIVER DADOS)       */}
        {/* ================================================= */}
        {(jurereIntro || jurereList.length > 0) && (
          <div className={alignClass}>
              <h4 className={`fonte-terciaria section-subtitle mb-4 reveal-element ${revealDirection} duration-12`}>
                  Jurerê
              </h4>
              <div className={`${alignTextoDestino} fonte-terciaria lead text-dark reveal-element ${revealDirection} duration-14`}>
                  
                  {jurereIntro && <p className="mb-4">{jurereIntro}</p>}

                  <ul className="text-start" style={{ listStyleType: 'none', paddingLeft: 0 }}>
                    {jurereList.map(item => (
                      <li key={item.id} className="mb-3 d-flex align-items-start">
                        <i className={`bi ${item.icon_class} fs-4 me-3`} style={{ color: 'var(--cor-secundaria-3)' }}></i>
                        <div>
                          <strong style={{ color: 'var(--cor-primaria-4)' }}>{item.title}: </strong>
                          {item.description}
                        </div>
                      </li>
                    ))}
                  </ul>
              </div>
          </div>
        )}

        {/* ================================================= */}
        {/* BLOCO 2: FLORIANÓPOLIS (SÓ APARECE SE TIVER DADOS)*/}
        {/* ================================================= */}
        {(floripaIntro || floripaList.length > 0) && (
          <div className={alignClass}>
              <h4 className={`fonte-terciaria section-subtitle mb-4 reveal-element ${revealDirection} duration-12`}>
                  Florianópolis
              </h4>
              
              <div className={`${alignTextoDestino} fonte-terciaria lead text-dark reveal-element ${revealDirection} duration-14`}>
                
                {floripaIntro && <p className="mb-4">{floripaIntro}</p>}
                
                <ul className="text-start" style={{ listStyleType: 'none', paddingLeft: 0 }}>
                  {floripaList.map(item => (
                    <li key={item.id} className="mb-3 d-flex align-items-start">
                      <i className={`bi ${item.icon_class} fs-4 me-3`} style={{ color: 'var(--cor-secundaria-3)' }}></i>
                      <div>
                        <strong style={{ color: 'var(--cor-primaria-4)' }}>{item.title}: </strong>
                        {item.description}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
          </div>
        )}

      </div>
    </section>
  );
};

export default FeaturesList;